export const Types: string[] = ['coverage', 'tags', 'behaviors'];
